export default __webpack_public_path__ + "static/media/hidepanel_SP.aa77e5c2.svg";